export const QUIT_LOGIN_CODE = [401];

export const DEFAULT_LANGUAGE = 'zh';

export const SUPPORT_LANGUAGE = ['zh', 'en'];

export const DECRYPT_KEY = 'Is-Decrypt';

export const OSS_DOMAIN = 'https://westnovo-oss.oss-us-west-1.aliyuncs.com';

// @ts-expect-error: NODE_ENV is injected globally by Webpack's DefinePlugin during build time.
export const IS_PROD = NODE_ENV === 'production';

// @ts-expect-error: MOCK is injected globally by Webpack's DefinePlugin during build time.
export const IS_MOCK = MOCK === 'true';

export enum API_CODE {
  SUCCESS = 0,
  ERROR = -1,
}

export const LOGIN_PAGE = '/login';

export const DEFAULT_REQUEST = {
  pageNo: 1,
  pageSize: 10,
};

export enum STATUS {
  ENABLE,
  DISABLED,
}

export const statusOptions = [
  {
    label: '启用',
    value: STATUS.ENABLE,
    className: 'text-[#0256FF] bg-[#F2F6FF]',
  },
  {
    label: '禁用',
    value: STATUS.DISABLED,
    className: 'text-[#F71413] bg-[#FEF3F3]',
  },
];

// 运单状态
export enum WAYBILL_STATUS {
  ALL = -1,
  INIT, // 初始状态
  UNCOLLECTED, // 待揽收
  COLLECTED, // 已揽收
  TRANSPORT, // 运输中
  SIGNED, // 已签收
  CANCELLED = 99, // 已取消
}

export const waybillStatusOptions = [
  {
    label: '全部',
    value: WAYBILL_STATUS.ALL,
  },
  {
    label: '初始状态',
    value: WAYBILL_STATUS.INIT,
    className: 'text-[#F71413] bg-[#FEF3F3]',
  },
  {
    label: '待揽收',
    value: WAYBILL_STATUS.UNCOLLECTED,
    className: 'text-[#F71413] bg-[#FEF3F3]',
  },
  {
    label: '已揽收',
    value: WAYBILL_STATUS.COLLECTED,
    className: 'text-[#0256FF] bg-[#F2F6FF]',
  },
  {
    label: '运输中',
    value: WAYBILL_STATUS.TRANSPORT,
    className: 'text-[#FB7703] bg-[#FFF8F2]',
  },
  {
    label: '已签收',
    value: WAYBILL_STATUS.SIGNED,
    className: 'text-[#1E1E1E] bg-[#F4F4F4]',
  },
  {
    label: '已取消',
    value: WAYBILL_STATUS.CANCELLED,
    className: 'text-[#1E1E1E] bg-[#F4F4F4]',
  },
];

export enum ORDER_STATUS {
  ALL = -1,
  DRAFT,
  NOPRICE,
  QUOTED,
  CREATED,
  ACCEPT,
  ARRIVED,
  CLOSED,
  DELETED = 9,
}

export const orderStatusOptions = [
  {
    label: '全部',
    value: ORDER_STATUS.ALL,
  },
  {
    label: '草稿',
    value: ORDER_STATUS.DRAFT,
    className: 'text-[#1E1E1E] bg-[#F4F4F4]',
  },
  {
    label: '待报价',
    value: ORDER_STATUS.NOPRICE,
    className: 'text-[#F71413] bg-[#FEF3F3]',
  },
  {
    label: '已报价',
    value: ORDER_STATUS.QUOTED,
    className: 'text-[#0256FF] bg-[#F2F6FF]',
  },
  {
    label: '已下单',
    value: ORDER_STATUS.CREATED,
    className: 'text-[#0256FF] bg-[#F2F6FF]',
  },
  {
    label: '在途中',
    value: ORDER_STATUS.ACCEPT,
    className: 'text-[#FB7703] bg-[#FFF8F2]',
  },
  {
    label: '已完成',
    value: ORDER_STATUS.ARRIVED,
    className: 'text-[#1E1E1E] bg-[#F4F4F4]',
  },
  {
    label: '已取消',
    value: ORDER_STATUS.CLOSED,
    className: 'text-[#1E1E1E] bg-[#F4F4F4]',
  },
  {
    label: '已删除',
    value: ORDER_STATUS.DELETED,
    className: 'text-[#1E1E1E] bg-[#F4F4F4]',
  },
];

export enum CUSTOMER_LEVEL {
  DEFAULT,
  S,
  A,
  B,
  C,
}

export const customerLevelOptions = [
  { label: '默认', value: CUSTOMER_LEVEL.DEFAULT },
  { label: 'S', value: CUSTOMER_LEVEL.S },
  { label: 'A', value: CUSTOMER_LEVEL.A },
  { label: 'B', value: CUSTOMER_LEVEL.B },
  { label: 'C', value: CUSTOMER_LEVEL.C },
];

export enum CUSTOMER_STATUS {
  REFUSE = -1, // 拒绝
  UNACTIVE, // 未激活
  ENABLE, // 启用
  DISABLED, // 禁用
}

export const customerStatusOptions = [
  {
    label: '拒绝',
    value: CUSTOMER_STATUS.REFUSE,
    className: 'text-[#F71413] bg-[#FEF3F3]',
  },
  {
    label: '未激活',
    value: CUSTOMER_STATUS.UNACTIVE,
    className: 'text-[#F71413] bg-[#FEF3F3]',
  },
  {
    label: '启用',
    value: CUSTOMER_STATUS.ENABLE,
    className: 'text-[#0256FF] bg-[#F2F6FF]',
  },
  {
    label: '禁用',
    value: CUSTOMER_STATUS.DISABLED,
    className: 'text-[#F71413] bg-[#FEF3F3]',
  },
];

export enum USER_STATUS {
  DISABLED, // 禁用
  ENABLE, // 启用
}

export const userStatusOptions = [
  {
    label: '启用',
    value: USER_STATUS.ENABLE,
    className: 'text-[#0256FF] bg-[#F2F6FF]',
  },
  {
    label: '禁用',
    value: USER_STATUS.DISABLED,
    className: 'text-[#F71413] bg-[#FEF3F3]',
  },
];

export enum STRATEGY {
  TWENTY_SIX = 1,
  FIFTY_THREE = 2,
}

export const strategyOptions = [
  {
    label: '26尺卡车',
    value: STRATEGY.TWENTY_SIX,
  },
  {
    label: '53尺卡车',
    value: STRATEGY.FIFTY_THREE,
  },
];

// 价格类型
export enum QUOTE_TYPE {
  STARTING_PRICE, // 起步价
  TRAY_PRICE, // 托盘价
  VEHICLE_PRICE, // 整车价
}

//  金额类型
export enum AMOUNT_TYPE {
  Standard = 1, // 标准报价
  WeightUpdate = 2, // 补齐重量
  Liftgate = 3, // liftgate
  ManualQuote = 4, // 手工报价
  PalletUpdate = 5, // 托数更新
  ManualHandling = 6, // 人工装卸
  EmptyRun = 7, // 空跑
  WaitTime = 8, // 等时
  Refuse = 9, // 拒收
  LTL2FTL = 10, // 零担转整车
  Other = 99, // 其他
}

export enum ProofType {
  None = 0, // 无凭证
  BOL = 1, // BOL
  POD = 2, // POD
  BOLAndPOD = 3, // BOL & POD
}

const isTest = location.host.includes('sit') || location.host.includes('localhost');

export const aliyunCaptchaSceneId = isTest ? '9sq7nxfe' : '19lvcrty';

export const PUBLIC_KEY = isTest
  ? 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC/YIvtgxLWPQGv+xv4bfAshfjoE/ozW6T5pxv6dI2KAIaHhEOAiM8iIXl3EXc2g1Ps7JTjwbBAKBsvCc50DIlszOSzJtnssIPwbwvk3qkpcQNOzLJhbR+viJQG66HJqj/ZzUfAJ6mHD1YKb4zcG6MwwtiPa2elPoblXr1r7n5bgQIDAQAB'
  : 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6SxwaTKGw2v+kIb8gI5jqwd8KwsA1OmsnSWuaME472J26YO+jy/MwMBVJgcJWCZcQ6iL1ppIGAV3883/fAyAlnQmedntGFfLucDNCTbH6VA8fKLmXvT63p8Uhs0nojdqhhfX/usFvaPsN3LnxpcJJGSitGnEUDL6og4Fgf1FIEQIDAQAB';

// 订单来源
export enum ORDER_SOURCE {
  // 客户自建
  CUSTOMER_SELF,
  // 运营代下单
  OPERATION_ORDER,
}

export const orderSourceOptions = [
  {
    label: '客户自建',
    value: ORDER_SOURCE.CUSTOMER_SELF,
  },
  {
    label: '运营代下单',
    value: ORDER_SOURCE.OPERATION_ORDER,
  },
];

// 运单渠道
export enum SHIPPING_CHANNEL {
  // westnovo
  WESTNOVO,
  // mothership
  MOTHERSHIP,
  // TQL
  TQL,
  SHIPNOVO,
}

export const shippingChannelOptions = [
  {
    label: 'westnovo',
    value: SHIPPING_CHANNEL.WESTNOVO,
  },
  {
    label: 'mothership',
    value: SHIPPING_CHANNEL.MOTHERSHIP,
  },
  {
    label: 'tql',
    value: SHIPPING_CHANNEL.TQL,
  },
  {
    label: 'shipnovo',
    value: SHIPPING_CHANNEL.SHIPNOVO,
  },
];

// 报价类型
export enum QUOTE_TYPE {
  // 平台报价
  PLATFORM_QUOTE = 1,
  // 增值服务报价
  SERVICE_QUOTE = 2,
}

export const quoteTypeOptions = [
  {
    label: '平台报价',
    value: QUOTE_TYPE.PLATFORM_QUOTE,
  },
  {
    label: '增值服务报价',
    value: QUOTE_TYPE.SERVICE_QUOTE,
  },
];

// 增值服务
export enum VALUE_ADDED_SERVICES {
  // liftgate
  LIFTGATE = '1',
  // alcohol
  ALCOHOL = '2',
  // appointment
  APPOINTMENT = '3',
  // cfs
  CFS = '4',
  // crossDock
  CROSSDOCK = '5',
  // hazmat
  HAZMAT = '6',
  // homeDelivery
  HOMEDELIVERY = '7',
  // inside
  INSIDE = '8',
  // limitedAccess
  LIMITEDACCESS = '9',
  // localInsideDelivery
  LOCALINSIDEDELIVERY = '10',
  // residential
  RESIDENTIAL = '11',
  // scheduledDelivery
  SCHEDULEDDELIVERY = '12',
  // sortSeg
  SORTSEG = '13',
  // tobacco
  TOBACCO = '14',
  // tradeshow
  TRADESHOW = '15',
  // twicRequired
  TWICREQUIRED = '16',
  CALLAHEAD = '17',
}
export const valueAddedServicesOptions = [
  {
    label: '升降门服务',
    value: VALUE_ADDED_SERVICES.LIFTGATE,
  },
  {
    label: '运输到住宅地址服务',
    value: VALUE_ADDED_SERVICES.RESIDENTIAL,
  },
  {
    label: '酒精运输服务',
    value: VALUE_ADDED_SERVICES.ALCOHOL,
  },
  {
    label: '预约送货服务',
    value: VALUE_ADDED_SERVICES.APPOINTMENT,
  },
  {
    label: '集装箱堆场服务',
    value: VALUE_ADDED_SERVICES.CFS,
  },
  {
    label: '直通服务',
    value: VALUE_ADDED_SERVICES.CROSSDOCK,
  },
  {
    label: '危险品运输服务',
    value: VALUE_ADDED_SERVICES.HAZMAT,
  },
  {
    label: '送货到家服务',
    value: VALUE_ADDED_SERVICES.HOMEDELIVERY,
  },
  {
    label: '送货到指定房间服务',
    value: VALUE_ADDED_SERVICES.INSIDE,
  },
  {
    label: '送货到限制地址服务',
    value: VALUE_ADDED_SERVICES.LIMITEDACCESS,
  },
  {
    label: '当地送货到室内服务',
    value: VALUE_ADDED_SERVICES.LOCALINSIDEDELIVERY,
  },
  {
    label: '运输到住宅地址服务',
    value: VALUE_ADDED_SERVICES.RESIDENTIAL,
  },
  {
    label: '指定时间送货服务',
    value: VALUE_ADDED_SERVICES.SCHEDULEDDELIVERY,
  },
  {
    label: '货物分类和分拣服务',
    value: VALUE_ADDED_SERVICES.SORTSEG,
  },
  {
    label: '烟草运输服务',
    value: VALUE_ADDED_SERVICES.TOBACCO,
  },
  {
    label: '展会运输服务',
    value: VALUE_ADDED_SERVICES.TRADESHOW,
  },
  {
    label: 'TWIC要求服务',
    value: VALUE_ADDED_SERVICES.TWICREQUIRED,
  },
  {
    label: '提前致电',
    value: VALUE_ADDED_SERVICES.CALLAHEAD,
  },
];

export const sendValueAddedServicesOptions = [
  {
    label: '升降门服务',
    value: VALUE_ADDED_SERVICES.LIFTGATE,
  },
  {
    label: '住宅地址取货服务',
    value: VALUE_ADDED_SERVICES.RESIDENTIAL,
  },
  {
    label: '集装箱堆场服务',
    value: VALUE_ADDED_SERVICES.CFS,
  },
  {
    label: '指定房间取货服务',
    value: VALUE_ADDED_SERVICES.INSIDE,
  },
  {
    label: '限制地址取货服务',
    value: VALUE_ADDED_SERVICES.LIMITEDACCESS,
  },
  {
    label: '展会运输服务',
    value: VALUE_ADDED_SERVICES.TRADESHOW,
  },
];

export const receiveValueAddedServicesOptions = [
  {
    label: '升降门服务',
    value: VALUE_ADDED_SERVICES.LIFTGATE,
  },
  {
    label: '运输到住宅地址服务',
    value: VALUE_ADDED_SERVICES.RESIDENTIAL,
  },
  {
    label: '预约送货服务',
    value: VALUE_ADDED_SERVICES.APPOINTMENT,
  },
  {
    label: '集装箱堆场服务',
    value: VALUE_ADDED_SERVICES.CFS,
  },
  {
    label: '送货到指定房间服务',
    value: VALUE_ADDED_SERVICES.INSIDE,
  },
  {
    label: '送货到限制地址服务',
    value: VALUE_ADDED_SERVICES.LIMITEDACCESS,
  },
  {
    label: '指定时间送货服务',
    value: VALUE_ADDED_SERVICES.SCHEDULEDDELIVERY,
  },
  {
    label: '展会运输服务',
    value: VALUE_ADDED_SERVICES.TRADESHOW,
  },
  {
    label: '提前致电',
    value: VALUE_ADDED_SERVICES.CALLAHEAD,
  },
  {
    label: '货物分类和分拣服务',
    value: VALUE_ADDED_SERVICES.SORTSEG,
  },
];

export enum Unit {
  IMPERIAL = 0,
  METRIC = 1,
}

export const unitOptions = [
  {
    label: '英制',
    value: Unit.IMPERIAL,
  },
  {
    label: '公制',
    value: Unit.METRIC,
  },
];

export const unitCopywriting = {
  [Unit.IMPERIAL]: {
    weight: '磅',
    size: '英寸',
  },
  [Unit.METRIC]: {
    weight: '千克',
    size: '厘米',
  },
};

export const unitAbbreviation = {
  [Unit.IMPERIAL]: {
    weight: 'lb',
    size: 'in',
  },
  [Unit.METRIC]: {
    weight: 'kg',
    size: 'cm',
  },
};

export enum QuoteMode {
  Standard = 0, // 标准长宽高模式
  Volume = 1, // 体积报价模式
}

export const quoteModeOptions = [
  {
    label: '标准长宽高模式',
    value: QuoteMode.Standard,
  },
  {
    label: '体积报价模式',
    value: QuoteMode.Volume,
  },
];

export const sourceOptions = [
  {
    label: '订单',
    value: 0,
  },
  {
    label: '运单',
    value: 1,
  },
];

export enum Platform {
  WestNovo,
  MotherShip,
  Tql,
  ShipNovo,
}

export const platformOptions = [
  {
    label: '自营',
    value: Platform.WestNovo,
  },
  {
    label: 'MotherShip',
    value: Platform.MotherShip,
  },
  {
    label: 'Tql',
    value: Platform.Tql,
  },
  {
    label: 'ShipNovo',
    value: Platform.ShipNovo,
  },
];
